var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{attrs:{"id":_vm.cb.name,"name":_vm.cb.name,"value":"done","unchecked-value":"todo","switch":""},on:{"change":function($event){return _vm.toggle()}},model:{value:(_vm.cb.status),callback:function ($$v) {_vm.$set(_vm.cb, "status", $$v)},expression:"cb.status"}})
}
var staticRenderFns = []

export { render, staticRenderFns }